module.exports = __webpack_public_path__ + "static/media/particle-circle.2b3d2fbf.png";